
// Get the value of the "utmMedium" cookie
const mediumValue = getCookieValue(cookieString, "utm_medium");
console.log("utm_medium:", mediumValue);

// Get the value of the "utmCampaign" cookie
const campaignValue = getCookieValue(cookieString, "utm_campaign");
console.log("utm_campaign:", campaignValue);


document.addEventListener("DOMContentLoaded", function(){
  executeCodeOnLoad();
});
const hiddenInput = document.querySelector('input[name="id"]');

// Function to handle mutations (changes) to the hidden input field
const mutationCallback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
      // Introduce a delay of 0.5 seconds before executing the function
      setTimeout(() => {
        console.log("Delayed execution after 0.5 seconds");
        executeCodeOnLoad();
      }, 1000); // 500 milliseconds (0.5 seconds)
          // Value of the hidden input field has changed
    }
  }
};

// Create a MutationObserver to observe changes to the hidden input field
const observer = new MutationObserver(mutationCallback);

// Start observing changes to the 'value' attribute of the hidden input field
if (hiddenInput && mediumValue !== null) {
  observer.observe(hiddenInput, { attributes: true });
}


function executeCodeOnLoad() {
  if (mediumValue !== null && (mediumValue.toLowerCase() === "email")){
    if (window.location.href.includes("/products")) {
      const amazonComButton = document.querySelector(".buy_on_amzn");
      if (amazonComButton) {
        let currentHref = amazonComButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_56DCE909169AA8DC4B704EBF88D90DCA_afap_abs');
        if (campaignValue !== null && (campaignValue.toLowerCase() === "emailmarketing_138396663897" || campaignValue.toLowerCase() === "emailmarketing_142193098841" )){
          //Subscribed
          currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_C29E8280122DE2243467EF59311C357B_afap_abs');
        }
        if (campaignValue !== null && (campaignValue.toLowerCase() === "emailmarketing_138463379545")) {
          //Abandoned
          currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_F1E30EE385A6A7584F0ABFF399E8EFF7_afap_abs');
        }
        amazonComButton.setAttribute("href", currentHref);
        console.log("replace-us");
      }
      const amazonUkButton = document.querySelector(".buy_on_amzn_uk");
      if (amazonUkButton) {
        let currentHref = amazonUkButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_43818A5ADB949C5676B36E8252F384BB_afap_abs');
        amazonUkButton.setAttribute("href", currentHref);
      }
    }
  }
   if (mediumValue !== null && (mediumValue.toLowerCase() === "cpc")){
    if (window.location.href.includes("/products")) {
      const amazonComButton = document.querySelector(".buy_on_amzn");
      if (amazonComButton) {
        let currentHref = amazonComButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_3736AD9831BE5EDB3D53EB2FAD21EA26_afap_abs');
        amazonComButton.setAttribute("href", currentHref);
        console.log("uscpc");
      }
      const amazonUkButton = document.querySelector(".buy_on_amzn_uk");
      if (amazonUkButton) {
        let currentHref = amazonUkButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_B73DF20EDF75D8792BEEAFF5E8B6EF75_afap_abs');
        amazonUkButton.setAttribute("href", currentHref);
      }
      if (campaignValue.toLowerCase() !== "brand_us"){
        document.getElementById("channel_box").style.display = "none"; 
      }
    }
  }
  if (mediumValue !== null && (mediumValue.toLowerCase() === "product_sync" || (campaignValue !== null && campaignValue.toLowerCase() === "sag_organic"))){
    if (window.location.href.includes("/products")) {
      const amazonComButton = document.querySelector(".buy_on_amzn");
      if (amazonComButton) {
        let currentHref = amazonComButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_58FAA599B6CE5BFCA739206DE883F1FD_afap_abs');
        amazonComButton.setAttribute("href", currentHref);
        console.log("us_shopping");
      }
    }
  }
  if (mediumValue !== null && (mediumValue.toLowerCase() === "kol")){
    if (window.location.href.includes("/products")) {
      const amazonComButton = document.querySelector(".buy_on_amzn");
      if (amazonComButton) {
        let currentHref = amazonComButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_E80559A3F4BB62667B9EE15214254869_afap_abs');
        amazonComButton.setAttribute("href", currentHref);
        console.log("uskol");
      }
      const amazonUkButton = document.querySelector(".buy_on_amzn_uk");
      if (amazonUkButton) {
        let currentHref = amazonUkButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_C7DC66D8E5DFE5618D6B42C4E8355D36_afap_abs');
        amazonUkButton.setAttribute("href", currentHref);
      }
    }
  }
  if (mediumValue !== null && (mediumValue.toLowerCase() === "sas")){
    if (window.location.href.includes("/products")) {
      const amazonComButton = document.querySelector(".buy_on_amzn");
      if (amazonComButton) {
        let currentHref = amazonComButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_168652AE2B47764DE0F5F24BEE792453_afap_abs');
        amazonComButton.setAttribute("href", currentHref);
        console.log("ussas");
      }
      const amazonUkButton = document.querySelector(".buy_on_amzn_uk");
      if (amazonUkButton) {
        let currentHref = amazonUkButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_FE4077228988FB575B14326CC679CF70_afap_abs');
        amazonUkButton.setAttribute("href", currentHref);
      }
    }
  }
  if (landingpageType !== null && landingpageType === "blog"){
    if (window.location.href.includes("/products")) {
      const amazonComButton = document.querySelector(".buy_on_amzn");
      if (amazonComButton) {
        let currentHref = amazonComButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_4D0F6982BE474C9D09466530B24C4ACF_afap_abs');
        amazonComButton.setAttribute("href", currentHref);
        console.log("us-blog");
      }
      const amazonUkButton = document.querySelector(".buy_on_amzn_uk");
      if (amazonUkButton) {
        let currentHref = amazonUkButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_6C4D6B0285302D1D07B0D492A668AF8B_afap_abs');
        amazonUkButton.setAttribute("href", currentHref);
      }
    }
  }
}